import React, { useEffect, useState } from 'react'
import { broadcastAPI } from '../Api'

export default function Broadcasts() {
  const [apikey, setApikey] = useState('')
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [targets, setTargets] = useState('')
  const [rate, setRate] = useState(1500)
  const [creating, setCreating] = useState(false)
  const [progress, setProgress] = useState([])
  const [adminKey, setAdminKey] = useState('')
  const [allProg, setAllProg] = useState([])
  const [error, setError] = useState('')

  async function loadProgress() {
    if (!apikey) return
    try {
      const r = await broadcastAPI.progress(apikey)
      setProgress(r.data?.data || [])
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'progress_failed'
      setError(msg)
    }
  }

  async function loadAll() {
    if (!adminKey) return
    try {
      const r = await broadcastAPI.all(adminKey)
      setAllProg(r.data?.data || [])
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'all_failed'
      setError(msg)
    }
  }

  async function onCreate(e) {
    e.preventDefault()
    setError('')
    try {
      setCreating(true)
      const payload = { apikey, title, message, targets, rate_limit_ms: Number(rate) || 1500 }
      await broadcastAPI.create(payload)
      setTitle(''); setMessage(''); setTargets('')
      // refresh
      setTimeout(loadProgress, 500)
    } catch (e) {
      const msg = e?.response?.data?.message || e?.message || 'create_failed'
      setError(msg)
    } finally { setCreating(false) }
  }

  useEffect(() => {
    const t = setInterval(() => { if (apikey) loadProgress(); if (adminKey) loadAll(); }, 2000)
    return () => clearInterval(t)
  }, [apikey, adminKey])

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Рассылки (TDLib, только аккаунты type=spam)</h1>

      {error ? <div className="mb-3 text-red-500 text-sm">{error}</div> : null}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border rounded p-4 bg-white">
          <h2 className="font-semibold mb-2">Создать рассылку (по API ключу мерчанта)</h2>
          <form onSubmit={onCreate} className="space-y-3">
            <div>
              <label className="block text-sm text-gray-600">API Key мерчанта</label>
              <input className="w-full border px-2 py-1" value={apikey} onChange={e=>setApikey(e.target.value)} placeholder="apikey" />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Заголовок (необязательно)</label>
              <input className="w-full border px-2 py-1" value={title} onChange={e=>setTitle(e.target.value)} placeholder="Название кампании" />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Сообщение</label>
              <textarea className="w-full border px-2 py-1 h-28" value={message} onChange={e=>setMessage(e.target.value)} placeholder="Текст сообщения" />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Цели (каждая с новой строки, chat_id или @username)</label>
              <textarea className="w-full border px-2 py-1 h-32" value={targets} onChange={e=>setTargets(e.target.value)} placeholder="123456789\n@username\n..." />
            </div>
            <div>
              <label className="block text-sm text-gray-600">Интервал отправки (мс)</label>
              <input type="number" className="w-full border px-2 py-1" value={rate} onChange={e=>setRate(e.target.value)} />
            </div>
            <button disabled={creating} className="bg-blue-600 text-white px-3 py-1 rounded">{creating ? 'Создание...' : 'Создать рассылку'}</button>
            <button type="button" onClick={loadProgress} className="ml-2 border px-3 py-1 rounded">Обновить прогресс</button>
          </form>

          <div className="mt-4">
            <h3 className="font-semibold mb-2">Прогресс по ключу</h3>
            <div className="space-y-2 max-h-64 overflow-auto">
              {progress && progress.length ? progress.map(b => (
                <div key={b._id} className="border rounded p-2">
                  <div className="text-sm font-medium">{b.title || '(без названия)'} — {b.status}</div>
                  <div className="text-xs text-gray-600">{new Date(b.createdAt).toLocaleString()}</div>
                  <div className="text-sm">{b.sent}/{b.total} отправлено, ошибок: {b.failed}</div>
                  {b.started_at ? <div className="text-xs">Старт: {new Date(b.started_at).toLocaleString()}</div> : null}
                  {b.finished_at ? <div className="text-xs">Финиш: {new Date(b.finished_at).toLocaleString()}</div> : null}
                </div>
              )) : <div className="text-sm text-gray-500">Нет данных</div>}
            </div>
          </div>
        </div>

        <div className="border rounded p-4 bg-white">
          <h2 className="font-semibold mb-2">Админ: все рассылки</h2>
          <div className="flex gap-2 mb-2">
            <input className="flex-1 border px-2 py-1" value={adminKey} onChange={e=>setAdminKey(e.target.value)} placeholder="BROADCAST_ADMIN_KEY" />
            <button onClick={loadAll} className="border px-3 py-1 rounded">Обновить</button>
          </div>
          <div className="space-y-2 max-h-[520px] overflow-auto">
            {allProg && allProg.length ? allProg.map(b => (
              <div key={b._id} className="border rounded p-2">
                <div className="text-sm font-medium">{b.title || '(без названия)'} — {b.status}</div>
                <div className="text-xs text-gray-600">{new Date(b.createdAt).toLocaleString()} | merchant: {b.apikey ? b.apikey.slice(0,6)+'…' : ''}</div>
                <div className="text-sm">{b.sent}/{b.total} отправлено, ошибок: {b.failed}</div>
              </div>
            )) : <div className="text-sm text-gray-500">Нет данных</div>}
          </div>
        </div>
      </div>
    </div>
  )
}
